export default __webpack_public_path__ + "static/media/insta_icon.d3863131.svg";